enum ECurrencyCode {
    ARS = 'ARS',
    AMD = 'AMD',
    CLP = 'CLP',
    INR = 'INR',
    KZT = 'KZT',
    KGS = 'KGS',
    MXN = 'MXN',
    PEN = 'PEN',
    RUB = 'RUB',
    RUR = 'RUR',
    USD = 'USD',
    UZS = 'UZS',
    AZN = 'AZN',
    XTS = 'XTS',
    EUR = 'EUR',
    XAF = 'XAF',
    UAH = 'UAH',
    BRL = 'BRL',
    COP = 'COP',
    Undefined = 'Undefined',
    Bonuses = 'Bonuses',

    // официально снят с поддержки
    // но пока не удален, т.к. поедут типы
    YandexDemoRub = 'YandexDemoRub',
}

const BONUSES_CURRENCY_SYMBOL = '&#x0042;';
// TODO:
// don't replace by CurrencyCode type, until ECurrencyCode removed
// will be a circular dependency
const BONUSES_CURRENCY_CODE = ECurrencyCode.Bonuses;

export {
    ECurrencyCode,
    BONUSES_CURRENCY_SYMBOL,
    BONUSES_CURRENCY_CODE,
}
